import { useEffect, useState } from 'react'
import usePuzzleStore from './usePuzzleStore'
import shallow from 'zustand/shallow'

export const usePuzzleConfig = initialPuzzle => {
  const [puzzle, set] = usePuzzleStore(
    state => [state.active, state.setActivePuzzle],
    shallow
  )
  useEffect(() => {
    typeof initialPuzzle !== undefined && set(initialPuzzle)
  }, [initialPuzzle, set])
  return [puzzle, set]
}

export const usePuzzlesReset = puzzles => {
  const [resetPuzzles, setResetPuzzles] = useState(null)
  useEffect(() => {
    setResetPuzzles(JSON.parse(JSON.stringify(puzzles)))
  }, [puzzles])
  return resetPuzzles
}

export default usePuzzleStore
